<template>
  <van-sticky :offset-top="0">
    <demo-block :title="('')">
      <van-nav-bar :title="('扫描二维码')" :left-text="('返回')" left-arrow @click-left="this.$router.push('chargeindex')">
        <template #right>
          <van-icon v-if="paytype===0 || paytype ===1" name="wechat-pay" size="18" />
          <van-icon v-if="paytype===2" name="alipay" size="18" />
        </template>
      </van-nav-bar>
    </demo-block>
  </van-sticky>
  <van-cell-group title="当前信息" inset>
    <van-cell title="当前状态" :value="statusText">
      
      <template #title>
        <van-tag :type ="status === 'ready'?'success':'danger'">{{statusText}}</van-tag>
        <van-button v-if="status !== 'scanning'" type="danger" icon="close" size="mini" @click="startScan(i)" style="margin-left: 5px;">扫一扫</van-button>
        
      </template>
      <template #value>
        <van-tag type="warning"  size="large">{{statusText}}</van-tag>
      </template>
    </van-cell>
  </van-cell-group>
  <van-overlay :show="isLoading" >
    <view class="wrapper">
      <view class="block" catch:tap="noop">
        <van-loading size="24px" color="#ffffff">{{ loadcontent }}</van-loading>
      </view>
    </view>
  </van-overlay>
  
</template>

<script>
  import { requestGetGenerateSignature } from '../../api/api'
  import { mapState, mapGetters, mapActions } from 'vuex'
  import { IsBlank, GetBrowserType } from '../../utils/tools/index'

import {
  Grid,
  GridItem,
  Image,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  Tag,
  Cell,
  CellGroup,
  Row,
  Col,
  CouponCell,
  CouponList,
  Popup,
  Icon,
  Dialog,
  Toast,
  NoticeBar,
  ActionBar,
  ActionBarButton,
  ActionBarIcon,
  Button,
  Sticky,
  NavBar,
  Overlay,
  Loading
} from "vant";

export default {
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Overlay.name]: Overlay,
    [Sticky.name]: Sticky,
    [NavBar.name]: NavBar,
    [Col.name]: Col,
    [Row.name]: Row,
    [CouponCell.name]: CouponCell,
    [CouponList.name]: CouponList,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [NoticeBar.name]: NoticeBar,
    [ActionBar.name]: ActionBar,
    [ActionBarButton.name]: ActionBarButton,
    [ActionBarIcon.name]: ActionBarIcon,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Loading.name]: Loading,
  },
  i18n: {
    "zh-CN": {
      text: "文字",
      route: "页面导航",
      gutter: "格子间距",
      square: "正方形格子",
      columnNum: "自定义列数",
      customContent: "自定义内容",
      urlRoute: "URL 跳转",
      vueRoute: "路由跳转",
      showBadge: "徽标提示",
      horizontal: "内容横排",
    },
    "en-US": {
      text: "Text",
      route: "Route",
      gutter: "Gutter",
      square: "Square",
      columnNum: "Column Num",
      customContent: "Custom Content",
      urlRoute: "URL",
      vueRoute: "Vue Router",
      showBadge: "Show Badge",
      horizontal: "Horizontal",
    },
  },
  watch: {
    active(val) {
      if (val === 1) {
        setTimeout(() => {
           // this.$router.push( '/useroption' + '?t111=' + new Date().getTime() );
        }, 500);
      }
    },
  },
  computed: {
    ...mapState({
      token: state => state.token,
      isbind: state => state.isbind,
      userinfo: state => state.userinfo,
      accesstoken: state => state.accesstoken,
      openid: state => state.openid,
      typekey: state => state.typekey
    }),
    ...mapGetters([
      'openidex',
      'hasopenid',
      'isReAuthLogin',
      'isGrid'
    ]),
    statusText() {
        const statusMap = {
            'init': '正在初始化...',
            'ready': '准备就绪',
            'scanning': '扫描中...',
            'scanned': '扫描完成',
            'error': '错误'
        };
        return statusMap[this.status] || '未知状态';
    },
    scanButtonText() {
        return this.status === 'scanning' ? '扫描中...' : '开始扫描二维码';
    }
  },
  data() {
    return {
      isExit: false,
      poscode: '',
      errorcode: true,
      errmsg: '加载中...',
      headpic: '',
      showQrCode: false,
      loadcontent: '加载中...',
      isLoading: false,
      dialogIcon: '',
      dialogTitle: '进入模式',
      chartindex: 0,
      dialogInScene: false,
      showScene: false,
      active: 0,
      charttitle: "用水信息",
      chosenCoupon: -1,
      exchangedCoupons: [],
      chargeinfo: {},
      paytype: 0,
      chargelist: [],
      qrcode: '',
      qrcodevaliddt: 0,
      qrcodeoversec: 0,
      menulist1: [],
      broadcastmsg: '本系统支持内部人员直接使用',
      ws: null,
      paymessage: '等待支付中...',
      qrcodeTimer: null,
      wsexit: false,
      timeDelay: 60,
      nTimeDelayInternal: null,
      nGetPortInternal: null,
      status: 'init', // init, ready, scanning, scanned
      result: null,
      error: null,
      resultType: 'text',
      resultTypeText: '文本',
      wechatConfig: {
        return_code: -1,
        return_message: '初始化状态',
        debug: false,
        appId: '', // 需要从后端获取
        timestamp: 0, // 需要从后端获取
        nonceStr: '', // 需要从后端获取
        signature: '', // 需要从后端获取
        jsApiList: ['checkJsApi','onMenushareTimeline','onMenushareAppMessage','scanQRCode']
      },
      isDebug: false
    };
  },
  async mounted() {
    this.paytype = GetBrowserType()
    console.log(this.paytype)
    this.isLoading=true
    // 如果有errcode代表是有错误发生了，直接显示错误信息\
    var $errcode = this.$route.query.errcode
    var $errmsg = this.$route.query.errmsg
    console.log(this.getLocalLoginInfo())
    if (IsBlank(this.$store.state.accesstoken)===true) {
      console.log('还没有任何信息，需要去绑定！')
      window.alert('ddd')
      Dialog.alert({
        title: '错误提醒',
        message: '首次使用，需要先绑定信息！' ,
      })
      setTimeout(() => {
        this.$router.push('#/index?t1=' + new Date().getTime());
      }, 1000);
      return;
    }
    console.log('___________________________________________')
      console.log('$errcode', $errcode)
      console.log('$errmsg', $errmsg)
      console.log('___________________________________________')
      console.log(IsBlank($errcode))
    if (IsBlank($errcode) === true) { // 为空
      this.errcode = false
      this.errmsg = '加载完成'
      this.errorcode = false
      // 如果accesstoken有信息，那就直接设置进去
      var $accesstoken = this.$store.state.accesstoken
      var $token = this.$store.state.localtoken
      console.log('___________________________________________')
      console.log('$token信息', $token)
      console.log('$accesstoken信息', $accesstoken)
      console.log('___________________________________________')
      if (IsBlank($accesstoken) === false) {
        this.isbind = true
      } 
      // this.GetSysInfo()
    } else {
      console.log('有错误信息出来了，不用跳转了')
      this.errcode = $errcode
      this.errmsg = $errmsg
    }

    setTimeout(() => {
      if (this.paytype==0) {
        console.log('微信浏览器，开始加载微信sdk')
        Toast('微信浏览器，开始加载微信sdk' );
        this.loadJsWx();
        this.initWeChatSDK();
      }
    }, 1000);
    this.isLoading=false
    console.log(this.userinfo)
    console.log(this.isbind)
    console.log(this.state)
    console.log('启动结束！')

  },
  beforeUnmount() {
    this.isExit=true
    if (this.nTimeDelayInternal!=null) clearInterval(this.nTimeDelayInternal)
    if (this.nGetPortInternal!=null) clearInterval(this.nGetPortInternal)
  },
  methods: {
    ...mapActions([
      'getLocalLoginInfo',
      'getIsNeedAuthLogin',
      'clearAccessToken',
      'getBaseUserInfo'
    ]),
    LoadQrCode(q) {
      if (IsBlank(q)==true) {
        Dialog.alert({
          title: '错误提醒',
          message: '二维码内容为空！！！',
        })
        setTimeout(() => {
          this.$router.push('#/chargeindex?t1=' + new Date().getTime());
        }, 300);
      } else {
        console.log('收到了二维码信息：' ,q);
        // 如果二维码信息有设备和端口信息，就直接去打开，否则只打开
        // window.alert(q);
        var isOk=false;
        var msg='';
        const a=this.parseUrlParams(q)
        if (a==null||a==undefined) {
          msg='非本系统二维码，请找到本系统二维码然后扫码！'
        } else {
          if (a.p==undefined) {
            msg='非本系统二维码，请找到本系统二维码然后扫码！'
          } else {
            if (a.d==undefined) {
              Toast({
                message: '充电桩模式，开始进入充电桩选择！' ,
                icon: 'success',
              });
              isOk=true;
              setTimeout(() => {
                this.$router.push('#/chargemachine?poscode=' + a.p +'&t1=' + new Date().getTime());
              }, 800);
              return;
            } else {
              Toast({
                message: '自动充电模式，开始进入获取插座信息！' ,
                icon: 'success',
              });
              setTimeout(() => {
                this.$router.push('#/chargemachine?poscode=' + a.p +'&portid='+ a.d +'&t1=' + new Date().getTime());
              }, 500);
              return;
            }
          }

        }
        if(isOk==false) {
          Toast({
            message: msg ,
            icon: 'fail',
          });
          setTimeout(() => {
            this.$router.push('#/chargeindex?t1=' + new Date().getTime());
          }, 300);
        }
      }
    },
    parseUrlParams(url) {
  // 方法1：使用 URLSearchParams（推荐）
      try {
        const hash = new URL(url).hash; // 获取 # 后的部分
        const queryString = hash.split('?')[1]; // 分割出参数部分
        if (!queryString) return null;
        
        const params = new URLSearchParams(queryString);
        console.log(params)
        return {
          p: params.get('p'),
          d: params.get('d')
        };
      } catch (e) {
        // 方法2：使用正则表达式（兼容性更强）
        const regex = /[?&](p|d)=([^&#]+)/g;
        const result = {};
        let match;
        
        while ((match = regex.exec(url)) !== null) {
          result[match[1]] = match[2];
        }
        
        return result.p && result.d ? result : null;
      }
    },
    loadJsWx() {
        const script = document.createElement('script');
        script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
        document.head.appendChild(script);
    },
    async getWechatConfig() {
      const res = await requestGetGenerateSignature({url: window.location.href, accesstoken: this.$store.state.accesstoken})
      if (res.return_code ==0) {
        this.wechatConfig.appId = res.data.appId;
        this.wechatConfig.timestamp = res.data.timestamp;
        this.wechatConfig.nonceStr = res.data.nonceStr;
        this.wechatConfig.signature = res.data.signature;
        this.wechatConfig.return_code =res.return_code;
        this.wechatConfig.return_message=res.return_message;

        return this.wechatConfig;
      } else
        this.wechatConfig.return_code =res.return_code;
        this.wechatConfig.return_message=res.return_message;
        Dialog.alert({
          title: '错误提醒',
          message: '获取微信配置失败：' + res.return_message,
        })
        setTimeout(() => {
          this.$router.push('#/chargeindex?t1=' + new Date().getTime());
        }, 300);
        return
    },
    async initWeChatSDK() {
        try {
          if (typeof window.wx == 'undefined') {
            this.loadJsWx();
          }
            // 实际项目中应调用后端接口获取配置
            const config = await this.getWechatConfig();
            if (config.return_code!=0) {
              Dialog.alert({
                title: '错误提醒',
                message: '获取微信配置失败：' + config.return_message,
              })
              setTimeout(() => {
                this.$router.push('#/chargeindex?t1=' + new Date().getTime());
              }, 300);
              return
            }
            this.wechatConfig.appId = config.appId;
            this.wechatConfig.timestamp = config.timestamp;
            this.wechatConfig.nonceStr = config.nonceStr;
            this.wechatConfig.signature = config.signature;
            // console.log(this.wechatConfig.jsApiList)
            console.log('配置文件获取成功，开始配置')
            Toast('配置文件获取成功，开始配置' );
            window.wx.config({
                debug: this.wechatConfig.debug,
                appId: this.wechatConfig.appId,
                timestamp: this.wechatConfig.timestamp,
                nonceStr: this.wechatConfig.nonceStr,
                signature: this.wechatConfig.signature,
                jsApiList: this.wechatConfig.jsApiList,
            });
            
            window.wx.ready(() => {
                this.status = 'ready';
                console.log('微信系统已经准备就绪' );
                Toast('微信系统已经准备就绪，开始扫描' );
                this.startScan();

            });
            
            window.wx.error((res) => {
                this.error = `微信SDK初始化失败: ${res.errMsg}`;
                console.log(this.error)
                this.status = 'error';
                Dialog.alert({
                  title: '错误',
                  message: '微信SDK初始化失败' + res.errMsg,
                })
                setTimeout(() => {
                  this.$router.push('#/chargeindex?t1=' + new Date().getTime());
                }, 300);
                return
            });
        } catch (err) {
            this.error = `获取配置失败: ${err.message}`;
            this.status = 'error';
            console.log(this.error)
            Dialog.alert({
              title: '错误',
              message: '微信配置失败：' + err.message,
            })
            setTimeout(() => {
              this.$router.push('#/chargeindex?t1=' + new Date().getTime());
            }, 300);
            return
        }
        setTimeout(() => {
          if (this.status=='init' || this.status=='error') { // 如果这里还是init说明有问题，不能用
            Toast({
                message: '摄像头初始化失败，请确认在微信中使用！' ,
                icon: 'fail',
              });
            this.$router.push('#/chargeindex?t1=' + new Date().getTime());
          }
        }, 1000);
        
        console.log(this.status)
    },
    startScan() {
      this.status = 'scanning';
      this.result = null;
      this.error = null;
      if (this.isDebug) {
        const q=' =1025000522&d=2'
        this.LoadQrCode(q)
      }
      window.wx.scanQRCode({
          needResult: 1,
          scanType: ["qrCode", "barCode"],
          success: (res) => {
              let resultStr = res.resultStr;
              console.log(res)
              // 处理扫描结果
              if (resultStr) {
                  this.result = resultStr;
                  this.LoadQrCode(resultStr);
                  
                  this.status = 'scanned';
              } else {
                  this.error = '未识别到二维码';
                  this.status = 'ready';
              }
          },
          fail: (err) => {
              this.error = `扫描失败: ${err.errMsg}`;
              this.status = 'ready';
              setTimeout(() => {
                this.$router.push('#/chargeindex?t1=' + new Date().getTime());
              }, 300);
              return
          },
          cancel: () => {
              this.status = 'ready';
              setTimeout(() => {
                this.$router.push('#/chargeindex?t1=' + new Date().getTime());
              }, 300);
              return
          }
    });
  }

  },
};
</script>
 
 
<style lang="less">
.van-grid {
  display: flex;
  flex-wrap: wrap;
}
.menugrid {
  // display: flex;
  flex-wrap: wrap;
  background-color: transparent;
  margin-bottom: 5px;
  // margin-left: 3px;
}
.van-grid-item__content {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    height: 100%;
    padding: var(--van-grid-item-content-padding);
    background: transparent;
}
.qrcodetext {
  margin-left: 5px;
  margin-top: 35px;
  color: #3c3c3f;
  font-size: 15px;
  font-family:"微软雅黑",Georgia,Serif;
}
.imageCharge {
  height: 55px;
}
.imgDialog {
  box-sizing: border-box;
  width: 100%;
  padding: 25px 20px 0;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
</style>
